import { LanguageModel } from "../survey/survey.model";
import { ImportLogError } from "./ImportLogError.model";
import { ImportQuestionByVersionResponse } from "./ImportQuestionByVersionResponse.model";
import { SurveyLanguage } from "./SurveyLanguage.model";

export class ImportResponseTraslationKey {
    isValid: boolean;
    countQuestions: number;
    languages: Array<LanguageModel>;
    errorLogs: Array<ImportLogError>;
    surveyLanguages: Array<SurveyLanguage>;
    questionsByVersion: Array<ImportQuestionByVersionResponse>;
  }


// WEBPACK FOOTER //
// ./src/app/models/csvImportError/ImportResponseTraslationKey.model.ts